import { render, staticRenderFns } from "./chatlist.vue?vue&type=template&id=3e5d31aa&scoped=true&"
import script from "./chatlist.vue?vue&type=script&lang=js&"
export * from "./chatlist.vue?vue&type=script&lang=js&"
import style0 from "./chatlist.vue?vue&type=style&index=0&id=3e5d31aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5d31aa",
  null
  
)

export default component.exports